import { Box, Theme, withStyles } from '@material-ui/core';
import FsBodySmallBold from 'ui-elements/typography/FsBodySmallBold';
import FsBodyBold from 'ui-elements/typography/FsBodyBold';

export const WrapperBox = withStyles(({ spacing, palette }: Theme) => ({
  root: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    borderRadius: spacing(0.5),
    padding: spacing(1.5),
    backgroundColor: palette.grey[100],
  },
}))(Box);

export const Caption = withStyles(({ palette }: Theme) => ({
  root: {
    color: palette.grey[400],
  },
}))(FsBodySmallBold);

export const Value = withStyles(() => ({
  root: {},
}))(FsBodyBold);
